<script>
  import { auth, logout, openLoginModal, closeLoginModal } from '../state/auth.svelte.js';
  import LoginModal from './LoginModal.svelte';

  let showLogoutConfirm = $state(false);

  function handleClick() {
    if (auth.isLoggedIn) {
      showLogoutConfirm = true;
    } else {
      openLoginModal();
    }
  }

  async function confirmLogout() {
    await logout();
    showLogoutConfirm = false;
  }

  function cancelLogout() {
    showLogoutConfirm = false;
  }
</script>

<button
  class="login-button"
  onclick={handleClick}
  disabled={auth.isLoading || auth.isRestoring}
>
  {#if auth.isLoggedIn}
    {auth.username || 'ACCOUNT'}
  {:else}
    LOGIN
  {/if}
</button>

{#if auth.showLoginModal && (!auth.isLoggedIn || auth.isLoading)}
  <LoginModal onClose={closeLoginModal} />
{/if}

{#if showLogoutConfirm}
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <div class="confirm-overlay" role="dialog" aria-modal="true" tabindex="-1" onclick={cancelLogout} onkeydown={(e) => e.key === 'Escape' && cancelLogout()}>
    <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
    <div class="confirm-dialog" role="document" onclick={(e) => e.stopPropagation()} onkeydown={(e) => e.stopPropagation()}>
      <p class="confirm-message">Sign out of <strong>{auth.username}</strong>?</p>
      <div class="confirm-actions">
        <button class="btn-secondary" onclick={cancelLogout}>Cancel</button>
        <button class="btn-logout" onclick={confirmLogout}>Sign Out</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .login-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    padding: 0 12px;
    border-radius: 18px;
    background: transparent;
    border: none;
    color: var(--color-text-muted);
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: normal;
    white-space: nowrap;
    line-height: 1;
    cursor: pointer;
    transition: color 0.2s ease;
  }

  .login-button:hover:not(:disabled) {
    color: var(--color-primary);
  }

  .login-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 639px) {
    .login-button {
      height: 32px;
      padding: 0 10px;
      font-size: 0.75rem;
    }
  }

  .confirm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
    animation: fadeIn 0.15s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .confirm-dialog {
    background: var(--color-bg);
    border-radius: 12px;
    padding: 24px;
    max-width: 320px;
    width: 100%;
    box-shadow: var(--shadow-lg);
    animation: slideIn 0.2s ease;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .confirm-message {
    margin: 0 0 20px 0;
    font-size: 1rem;
    color: var(--color-text);
    text-align: center;
  }

  .confirm-message strong {
    color: var(--color-primary);
  }

  .confirm-actions {
    display: flex;
    gap: 12px;
  }

  .confirm-actions button {
    flex: 1;
    padding: 10px 16px;
    font-size: 0.9rem;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .btn-secondary {
    background: var(--color-surface);
    color: var(--color-text);
    border: 2px solid var(--color-border);
  }

  .btn-secondary:hover {
    border-color: var(--color-primary);
    color: var(--color-primary);
  }

  .btn-logout {
    background: var(--color-error);
    color: white;
    border: none;
  }

  .btn-logout:hover {
    filter: brightness(0.9);
  }
</style>
